export default "__VITE_ASSET__TC6$9QR2__"